import React from 'react';
import { ProfileOutlined, FormOutlined, TeamOutlined } from '@ant-design/icons';
import AppIconGroup from '../../components/app-icon-group';
import UserList from './user-list';
import SwitchShop from '../shop/switch-shop';
import { getCurrentShopId } from '../shop/get-current-shop';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const [shopId, setShopId] = React.useState(null);

    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);

    return (
        <div>
            <SwitchShop />
            
            {/* 快捷操作 - iOS 风格图标组 */}
            <div className="mt-3 mb-4">
                <AppIconGroup 
                    items={[
                        {
                            id: 1,
                            href: '/account/create',
                            title: '创建账号',
                            icon: <FormOutlined />,
                            color: 'from-blue-500 to-blue-600'
                        },
                        !window.__baseInfo.isSub && {
                            id: 2,
                            href: '/account/role',
                            title: '角色管理',
                            icon: <TeamOutlined />,
                            color: 'from-green-500 to-green-600'
                        },
                        {
                            id: 3,
                            href: '/account/profile',
                            title: '账户资料',
                            icon: <ProfileOutlined />,
                            color: 'from-purple-500 to-purple-600'
                        }
                    ].filter(Boolean)}
                    cols="3-3-3-3-3"
                />
            </div>
            
            <h2 className="admin-page-title">账号列表</h2>
            <UserList shopId={shopId} />
        </div>
    )
}